import { createStyles } from '@material-ui/core/styles';

export default createStyles({

  resultContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    height: '100%'
  },
  rightContainer: {
    marginLeft: '15px',
    width: '270px',
    maxWidth: '270px'
  },
  leftContainer: {
    width: 'calc(100% - 285px)'
  },
  calculatorDialog: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    marginRight: '20px'
  },
  calculatorDialogContainer: {
    padding: '10px',
    backgroundColor: 'white',
    borderRadius: '4px 4px 0px 0px',
    height: ' calc(100% - 100px)'
  },
  costContainer: {
    display: 'flex'
  },
  calculatorFooter: {
    backgroundColor: '#E5E5E5',
    padding: '10px',
    height: '60px',
    borderRadius: '0px 0px 4px 4px',
    display: 'flex',
    flexWrap: 'nowrap',
    flexDirection: 'row-reverse'
  },
  calculateButton: {
    'boxShadow': 'none',
    'borderRadius': 0,
    'backgroundColor': '#E5E5E5',
    '&.MuiButton-disabled': {
      backgroundColor: 'unset'
    }
  },
  switchBase: {
    '&$checked': {
      '& + $bar': {
        backgroundColor: '#6DD900',
        opacity: 1
      },
    },
  },
  bar: {},
  checked: {},
  formControlLabel: {
    '&$disabled': {
      color: '#555555',
    },
  },
  disabled: {

  }
});
